import axios from "axios";
import { baseUrl } from "../constants/ApiSettings";
import * as qs from "query-string-for-all";
import * as React from "react";
import SecondaryButton from "./SecondaryButton";
import Select from "react-select";
import { connect } from "react-redux";
import { fetchCouncils, fetchYears } from "../actions";
import { Dispatch } from "redux";
import Loading from './general/Loading';

interface IState {
  formProgress: number;
  selectProgress: number;
  primaryCouncil: IOption | undefined;
  councils: IOption[];
  selectedCouncils: string[];
  councilFilter: string | null;
  comparativeData: any |  null;
}

interface IProps {
  history: {
    push: (options: object) => void;
  };
  fetchCouncils: (councils: IOption[]) => void;
  fetchYears: (years: string[]) => void;
  councils: IOption[];
}

interface IOption {
  label: string;
  value: string;
}

const filterStrings = {
  nearby: "Councils nearby",
  population: "Councils with similar population",
  revenue: "Councils with similar revenue",
  recommended: "Recommended councils"
};

const maxSelectableCouncils = 3;

class SelectForm extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      councilFilter: null,
      councils: [],
      formProgress: 0,
      primaryCouncil: undefined,
      selectProgress: 0,
      selectedCouncils: [],
      comparativeData: []
    };
  }

  public componentDidMount() {
    axios
      .get(`${baseUrl}/councils?${qs.stringify({
              participation: "Yes"
      })}`)
      .then(response => {
        this.props.fetchCouncils(
          response.data.map((council: { id: number; string: string }) => ({
            label: council.string,
            value: council.id,
          }))
        );
      })
      // tslint:disable-next-line:no-console
      .catch(err => console.error(err));
  }

  public componentDidUpdate() {
    this.setState({ councils: this.props.councils });
  }

  public enoughSelected() {
    return this.state.selectedCouncils.length < 3
  }

  public render() {
    if (this.state.councils.length === 0) {
      return <Loading vertical={true} />;
    }

    const filteredListItems = this.filterItems( this.state.councilFilter );

    return (
      <div className={`h-full font-montserrat w-full`}>
        <div
          className={`h-full selectForm progress-${this.state.formProgress}`}
        >
          {/* Page 1 */}
          <div className="form-page form-page--0 py-6 container lg:items-center flex-wrap">
            <div className="w-full">
              <h2 className="form-heading">Find your council to get started</h2>
              <div className="my-4 w-full">
                <label
                  htmlFor="councilSelect"
                  className="font-montserrat block text-sm"
                >
                  Search for your council here
                </label>
                <Select
                  className="w-full mt-1"
                  name="councilSelect"
                  options={this.state.councils}
                  onChange={this.handlePrimaryCouncilChange}
                />
              </div>
              <button
                className="cta px-8"
                onClick={!!this.state.primaryCouncil ? this.nextPage : undefined}
                role="button"
                disabled={!this.state.primaryCouncil}
              >
                Continue
              </button>
              <p className="home-disclaimer text-xs mt-10">This website provides information and data for all Queensland councils who have agreed to participate in the My Council Story initiative. If you have any questions or require further information please contact the LGAQ via <a href="mailto:ask@lgaq.asn.au?Subject=My Council Story">ask@lgaq.asn.au</a>.</p>
            </div>
          </div>
          {/* Page 2 */}
          <div className="form-page form-page--1 container lg:items-center flex-wrap">
            <div className="w-full pt-20 relative">
              <SecondaryButton onClick={this.prevPage} label="Change Council" />
              <h2 className="form-heading">
                Select the councils you want to compare, from any category
              </h2>
              <div className="border-b w-full">
                <div className="py-4 w-full font-montserrat text-sm font-bold flex flex-row justify-between">
                  <div className="mt-2">
                    <span className="inline-block mr-2 mb-2">My council selected:</span>
                    <span className="inline-block border border-cct-green text-cct-green rounded py-1 px-2 mb-2">
                      {!!this.state.primaryCouncil
                        ? this.state.primaryCouncil.label
                        : ""}
                    </span>
                  </div>
                  {this.state.councilFilter !== null ? (
                    <button
                        className={this.enoughSelected() ? 'cta-disabled' : 'cta'}
                        onClick={this.enoughSelected() ? undefined : this.handleViewReports }
                    >
                      View Reports
                    </button>
                  ) : null}
                </div>
                {this.state.councilFilter !== null ? (
                  <span className={this.enoughSelected() ? 'border border-cct-red text-cct-red rounded py-1 px-2 text-xs mb-4 inline-block' : 'border border-cct-green text-cct-green rounded py-1 px-2 text-xs mb-4 inline-block'}>
                    {this.state.selectedCouncils.length} of{" "}
                    {maxSelectableCouncils} councils selected for comparison
                  </span>
                ) : null}
              </div>
              <div className="w-full overflow-x-hidden">
                <div
                  className={`w-2xfull font-montserrat selectSlider progress-${
                    this.state.selectProgress
                  } flex flex-row`}
                >
                  <div className="selectSlider-page selectSlider-page--0 w-full flex flex-col">
                    {["nearby", "revenue", "population"].map((filter: string, index: number) => (
                      <button
                        key={index}
                        className="w-full py-4 font-bold border-b text-left focus:outline-none"
                        onClick={() => this.handleCouncilFilterChange(filter)}
                      >
                        {filterStrings[filter]}
                      </button>
                    ))}
                  </div>
                  <div className="selectSlider-page selectSlider-page--1 w-full">
                    <button
                      className="w-full py-4 font-bold border-b text-left focus:outline-none"
                      onClick={() => this.unsetFilter()}
                    >
                      <i className="fa fa-long-arrow-left mr-2 px-2 py-2 rounded-full text-grey-darkest bg-grey-light" />
                      {this.state.councilFilter !== null
                        ? filterStrings[this.state.councilFilter]
                        : "Invalid filter selected"}
                    </button>
                    <ul className="list-reset">{ ( this.renderFilteredItems( filteredListItems ).length > 0 ) ?
                        this.renderFilteredItems( filteredListItems )
                      : (
                        <li className="py-5">No councils available for comparison.</li>
                      ) }</ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private handleViewReports = () => {
    const { primaryCouncil, selectedCouncils } = this.state;
    if (primaryCouncil) {
      const queryParams = { primaryCouncil: primaryCouncil.value };
      selectedCouncils.forEach((id: string, index: number) => {
        queryParams[`c${index}`] = id;
      });
      this.props.history.push({
        pathname: "/report",
        search: qs.stringify(queryParams)
      });
    }
  };

  private filterItems = ( filterType: any ) => {
    let filteredCouncils: any;
      switch ( filterType ) {
        // case "recommended":
        //   filteredCouncils = [{label: "Your Suggestions Will Go Here..."}];
        //   break;
        case "revenue":
          filteredCouncils = this.state.councils.filter(
            council =>
                this.state.primaryCouncil &&
                    council.value !== this.state.primaryCouncil.value &&
                    this.state.comparativeData.revenue.indexOf(council.value) !== -1
          );
          break;
        case "nearby":
          filteredCouncils = this.state.councils.filter(
            council =>
                this.state.primaryCouncil &&
                    council.value !== this.state.primaryCouncil.value &&
                    this.state.comparativeData.location.indexOf(council.value) !== -1
          );
          break;
        case "population":
          filteredCouncils = this.state.councils.filter(
            council =>
                this.state.primaryCouncil &&
                    council.value !== this.state.primaryCouncil.value &&
                    this.state.comparativeData.population.indexOf(council.value) !== -1
          );
          break;
        default:
          filteredCouncils = this.state.councils.filter(
              council =>
                  this.state.primaryCouncil &&
                        council.value !== this.state.primaryCouncil.value
          );
          break;
    }
      return filteredCouncils;
  };

  private renderFilteredItems = ( filteredCouncilList: any ) => {
      return filteredCouncilList.map((council: IOption, index: number) => (
          <li
              className="flex flex-row w-full border-b cursor-pointer hover:bg-grey-lightest items-center"
              key={index}
          >
              <input
                  type="checkbox"
                  className="cursor-pointer mx-2"
                  name={`council-${council.value}`}
                  id={`council-${council.value}`}
                  hidden={council.label === "Your Suggestions Will Go Here..."}
                  checked={this.state.selectedCouncils.indexOf(council.value) > -1}
                  onChange={_e => council.label === "Your Suggestions Will Go Here..." ? undefined : this.handleCouncilSelected(council.value)}
              />
              <label
                  htmlFor={`council-${council.value}`}
                  className="flex-1 cursor-pointer py-4"
              >
                  {council.label}
              </label>
          </li>
      ));
  };

    private handleCouncilSelected = (id: string) => {
        const currentIndex = this.state.selectedCouncils.indexOf(id);
        let selectedCouncils;
        if (currentIndex > -1) {
            selectedCouncils = this.state.selectedCouncils.filter(
                (councilId: string) => councilId !== id
            );
        } else if (this.state.selectedCouncils.length < maxSelectableCouncils) {
            selectedCouncils = [...this.state.selectedCouncils, id];
        } else {
            selectedCouncils = this.state.selectedCouncils;
        }
        this.setState({ selectedCouncils });
    };

    private nextPage = () => {
        const progress = this.state.formProgress;
        this.setState({ formProgress: progress + 1 });
    };

    private prevPage = () => {
        const progress = this.state.formProgress;
        this.setState({ selectedCouncils: [] });
        this.setState({ councilFilter: null });
        this.setState({ selectProgress: 0 });
        this.setState({ formProgress: progress - 1 });
    };

    private unsetFilter = () => {
        this.setState({
            // councilFilter: null,
            selectProgress: 0,
            // selectedCouncils: []
        });
    };

    private handleCouncilFilterChange = (councilFilter: string) => {
        this.setState({ selectProgress: 1, councilFilter });
    };

    private handlePrimaryCouncilChange = (primaryCouncil: IOption) => {
        this.setState({ primaryCouncil });
        axios
            .get(`${baseUrl}/comparativeData?${qs.stringify({
              "council ID": primaryCouncil.value,

            })}`)
            .then(response => {
              const comparisons = {
                revenue: [] as number[],
                location: [] as number[],
                population: [] as number[],
              }
              response.data.forEach((data: any) => {
                switch(data.criteria) {
                  case "Border":
                    comparisons.location.push(data.comparison);
                    break;
                  case "Population":
                    comparisons.population.push(data.comparison);
                    break;
                  case "Revenue":
                    comparisons.revenue.push(data.comparison);
                    break;
                }
              })
              // tslint:disable-next-line:no-console
              // console.log(comparisons);
              this.setState({...this.state, comparativeData: comparisons})
            })
              // tslint:disable-next-line:no-console
              .catch(err => console.error(err));
  };
}

const mapStateToProps = (state: any) => ({
  councils: state.selectables.councils,
  loading: state.selectables.councils.length > 0
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchCouncils: (councils: any[]) => dispatch(fetchCouncils(councils)),
  fetchYears: (years: string[]) => dispatch(fetchYears(years))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectForm);



// WEBPACK FOOTER //
// ./src/components/SelectForm.tsx